// @flow

import { List } from 'immutable';

const countsCellConfig = { size: 'small', align: 'center' };

export const columns = List([
  {
    label: 'app.forms.alerts.id',
    sortOrder: List([List(['ID'])]),
    columnWidth: 70,
  },
  {
    label: 'app.forms.patient.name',
    sortOrder: List([List(['FIRST_NAME']), List(['LAST_NAME'])]),
    columnWidth: 140,
  },
  {
    label: 'app.forms.alerts.dose-count',
    cellConfig: countsCellConfig,
    columnWidth: 104,
  },
  {
    label: 'app.forms.reviewer',
    sortOrder: List([List(['REVIEWER_FIRST_NAME']), List(['REVIEWER_LAST_NAME'])]),
    columnWidth: 130,
  },
  {
    label: 'app.forms.care.team',
    sortOrder: List([List(['CARE_TEAM_MEMBER_FIRST_NAME']), List(['CARE_TEAM_MEMBER_LAST_NAME'])]),
    columnWidth: 130,
  },
  {
    label: 'app.forms.alerts.condition',
    sortOrder: List([List(['CONDITION_NAME'])]),
    columnWidth: 150,
  },
  {
    label: 'app.forms.alerts.timestamp',
    sortOrder: List([List(['SUBMISSION_TIMESTAMP'])]),
    columnWidth: 125,
  },
  {
    label: 'app.forms.alerts.unreviewed',
    sortOrder: List([List(['UNREVIEWED_COUNT'])]),
    cellConfig: countsCellConfig,
    columnWidth: 100,
  },
  {
    label: 'app.forms.alerts.missed-medication',
    sortOrder: List([List(['MISSED_MEDICATION_COUNT'])]),
    cellConfig: countsCellConfig,
    columnWidth: 75,
  },
  {
    label: 'app.forms.alerts.side-effects',
    sortOrder: List([List(['SIDE_EFFECTS_COUNT'])]),
    cellConfig: countsCellConfig,
    columnWidth: 95,
  },
  {
    label: 'app.forms.alerts.regimen',
    sortOrder: List([List(['REGIMEN_ORDER'])]),
    cellConfig: countsCellConfig,
    columnWidth: 86,
  },
]);

export const columnsWithMessages = columns.push({
  label: 'app.forms.alerts.messages',
  sortOrder: List([List(['UNREAD_MESSAGES_COUNT'])]),
  cellConfig: countsCellConfig,
  columnWidth: 90,
});

export const reasonTypes = {
  UNREVIEWED: {
    REDIRECTION: 'UNREVIEWED',
    LABEL: 'unreviewed',
  },
  MISSED: {
    REDIRECTION: 'MISSED',
    LABEL: 'missed',
  },
  REPORTED: {
    REDIRECTION: 'SYMPTOMS',
    LABEL: 'reported',
  },
  UNREAD_MESSAGES: {
    REDIRECTION: 'UNREAD_MESSAGES',
    LABEL: 'unread',
  },
  REGIMEN: {
    REDIRECTION: 'REGIMEN',
    LABEL: 'regimen',
    LABEL2: 'no-regimen',
  },
  UNREAD_FAXES: {
    REDIRECTION: 'UNREAD_FAXES',
    LABEL: 'unread-faxes',
  },
};

export const relevantTodoDashboardPermissions = [
  'todoNewPatientsDashboard',
  'todoAllPatientsDashboard',
  'todoUnreadMessagesDashboard',
  'todoFaxFollowUpDashboard',
];

export const PAGE_SIZE = 50;
